/**
 * Contract Types Module
 */
(function(){
    'use strict';

    angular.module('elogbooks.admin.contract-types', []);
})();
